module.exports = __webpack_public_path__ + "img/img3_mobile.6a89e14c.png";